import { Component, OnInit, ViewChild, forwardRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MarvDrawerComponent } from '@marv/components';
import { AlertModalService } from '@app/services';
import { AlertListComponent } from '@app/components';

@Component({
    selector: 'app-alert-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [TranslatePipe, forwardRef(() => MarvDrawerComponent), forwardRef(() => AlertListComponent)]
})
export class AlertModalComponent  implements OnInit {

    @ViewChild('drawerAlerts') drawerAlerts: MarvDrawerComponent;

    onToggleAlertModalSubscription: Subscription;

    constructor(
        private alertModalService: AlertModalService
    ) { }

    ngOnInit() {
        this.onToggleAlertModalSubscription = this.alertModalService.onToggleAlertModal.subscribe(isOpened => {
            if(isOpened){
                this.drawerAlerts.open();
            }
            else{
                this.drawerAlerts.close();
            }
        });
    }
    
    ngOnDestroy() {
        if(this.onToggleAlertModalSubscription){
            this.onToggleAlertModalSubscription.unsubscribe();
        }
    }

    onDidDismissDrawerAlerts($event: any){
        if($event.detail?.data?.resetDrawer){
                  
        }               
    }
}
